import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { MatTooltipTruncateModule } from '@y42/core/mat-tooltip-truncate';
import { TemplateContextGuardModule } from '@y42/core/template-context-guard';
import { TimeAgoModule } from '@y42/date-time';
import { GitBranchFilterModule } from '@y42/git/shared/branch-filter';
import { GitBranchListModule } from '@y42/git/shared/branch-list';
import { GitBranchNameDisplayModule } from '@y42/git/shared/branch-name-display';
import { MonacoEditorModule } from '@y42/monaco-editor';
import { UserAvatarComponent } from '@y42/user/shared/user-avatar';
import { AngularSplitModule } from 'angular-split';
import { GitDiffTreeModule } from '../git-diff-tree';
import { GitCommitDetailsComponent } from './git-commit-details/git-commit-details.component';
import { GitCommitItemComponent } from './git-commits-list/git-commit-item/git-commit-item.component';
import { GitCommitsListComponent } from './git-commits-list/git-commits-list.component';
import { GitFileBlameComponent } from './git-file-blame/git-file-blame.component';
import { GitHistoryDialogComponent } from './git-history-dialog.component';

@NgModule({
  declarations: [
    GitHistoryDialogComponent,
    GitCommitDetailsComponent,
    GitCommitsListComponent,
    GitCommitItemComponent,
    GitFileBlameComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipTruncateModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatProgressBarModule,
    MatRadioModule,
    A11yModule,
    MatTooltipModule,
    LogoLoaderModule,
    AngularSplitModule,
    TimeAgoModule,
    FontAwesomeModule,
    MonacoEditorModule,
    ScrollingModule,
    GitBranchFilterModule,
    GitBranchListModule,
    TemplateContextGuardModule,
    UserAvatarComponent,
    GitDiffTreeModule,
    GitBranchNameDisplayModule,
  ],
  exports: [GitBranchNameDisplayModule],
})
export class GitHistoryDialogModule {}
